// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EstateListContainer_wrapper__3PsT3","container":"EstateListContainer_container__1iwPD"};